<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
    @click:outside="cancel"
  >
    <v-card>
      <!-- <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar> -->
      <v-container
        fluid
        :class="{
          'px-10': !mobile,
          'pt-8': !mobile,
          'px-4': mobile
        }"
      >
        <p class="subtitle-1 font-weight-bold">{{ title }}</p>
        <v-card-text v-show="!!message" class="pa-0">
          <p class="body-1">{{ message }}</p>
        </v-card-text>
        <v-card-actions :class="{ 'pt-4': !mobile, 'pt-1': mobile }">
          <v-spacer></v-spacer>
          <v-btn
            class="font-weight-bold"
            color="primary darken-1"
            text
            @click.native="agree"
            >{{ confirmText || 'Yes' }}</v-btn
          >
          <v-btn
            v-if="showDeny"
            class="font-weight-bold"
            color="red"
            text
            @click.native="deny"
            >{{ confirmText || 'No' }}</v-btn
          >
          <v-btn
            v-if="!reconfirmOnly"
            class="font-weight-bold"
            color="grey darken-1"
            text
            @click.native="cancel"
            >{{ cancelText || 'Cancel' }}</v-btn
          >
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Vuetify Confirm Dialog component
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {})
 * Or use await:
 * if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
 *   // yes
 * }
 * else {
 *   // cancel
 * }
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open
 * }
 */
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    confirmText: null,
    denyText: null,
    cancelText: null,
    defaultOptions: {
      color: 'primary',
      width: 350,
      zIndex: 200
    },
    options: {
      color: 'primary',
      width: 350,
      zIndex: 200
    },
    reconfirmOnly: false,
    showDeny: false
  }),
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  methods: {
    open(params) {
      const {
        title,
        message,
        options,
        reconfirmOnly,
        confirmText,
        denyText,
        cancelText,
        showDeny
      } = params
      this.dialog = true
      this.title = title
      this.message = message
      this.reconfirmOnly = reconfirmOnly
      this.confirmText = confirmText
      this.denyText = denyText
      this.cancelText = cancelText
      this.showDeny = showDeny
      this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree() {
      this.options = this.defaultOptions
      this.resolve(true)
      this.dialog = false
    },
    deny() {
      this.options = this.defaultOptions
      this.resolve('deny')
      this.dialog = false
    },
    cancel() {
      this.options = this.defaultOptions
      this.resolve(false)
      this.dialog = false
    }
  }
}
</script>

<style scoped>
.v-dialog {
  border-radius: 12px !important;
}
.body-1 {
  white-space: pre-wrap;
}
</style>
